import { AxiosError } from "axios"
import { paths } from "./schema"
import { useAppStore } from "../state"
import { createClient } from "../../lib/openapi-axios"
import { ProcessPaths } from "@src/utils/types"
import { API_BASE_URL, QUERY_CACHE_DB_NAME } from "@src/utils/consts"

const ANONYMOUS_ROUTE_PREFIXES = [
  "/application-definition",
  "/api/Outlook/SignIn",
  "/events/public/join",
] as const

export const client = createClient<ProcessPaths<paths>>({
  baseUrl: API_BASE_URL,
})

client.axiosInstance.interceptors.request.use((config) => {
  const token = useAppStore.getState().token

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`
  }

  return config
})

client.axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      const { adminToken } = useAppStore.getState()

      if (adminToken) {
        // Impersonation session expired — restore admin token
        useAppStore.setState({ token: adminToken, adminToken: undefined })
        indexedDB.deleteDatabase(QUERY_CACHE_DB_NAME)
        window.location.href = "/super-admin/users"
      } else {
        useAppStore.setState({ token: "" })
        // Clear persisted query cache so stale user data isn't used on next login
        indexedDB.deleteDatabase(QUERY_CACHE_DB_NAME)
        // prevent redirecting to login if already on login page or anonymous route
        const isAnonymousRoute = ANONYMOUS_ROUTE_PREFIXES.some((prefix) =>
          window.location.pathname.startsWith(prefix),
        )
        if (window.location.pathname !== "/login" && !isAnonymousRoute) {
          const { pathname, search, hash } = window.location
          const redirect = encodeURIComponent(`${pathname}${search}${hash}`)
          window.location.href = `/login?redirect=${redirect}`
        }
      }
    }
    return Promise.reject(error)
  },
)
